export var Layout;
(function (Layout) {
    Layout["GRID"] = "grid";
    Layout["LIST"] = "list";
})(Layout || (Layout = {}));
// TODO: move to store or use store or snapi types
export var FacetType;
(function (FacetType) {
    FacetType["VALUE"] = "value";
    FacetType["RANGE"] = "range";
    FacetType["RANGE_BUCKETS"] = "range-buckets";
})(FacetType || (FacetType = {}));
// TODO: should be added to the Facet type
export var FacetDisplay;
(function (FacetDisplay) {
    FacetDisplay["GRID"] = "grid";
    FacetDisplay["PALETTE"] = "palette";
    FacetDisplay["LIST"] = "list";
    FacetDisplay["SLIDER"] = "slider";
    FacetDisplay["HIERARCHY"] = "hierarchy";
})(FacetDisplay || (FacetDisplay = {}));
